import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useSearchParams } from 'react-router-dom';
import { format } from 'date-fns';

import { Button, ErrorLoading, ListNoData, Pagination } from '../../../../../components/common';
import { changePageInfo } from '../../../../../state/store/reducers/ui/headerSlice';
import { paginationInfo } from '../../../../../utils/pagination';
import PopoverWithFloat from '../../../../../components/hoc/PopoverWithFloat';
import { ListLoader } from '../../../../../components/loaders';
import useToast from '../../../../../state/hooks/useToast';
import useAlert from '../../../../../state/hooks/useAlert';
import usePagedListApi from '../../../../../state/hooks/usePagedListApi';
import paymentsService from '../../../../../services/api/payments/paymentsService';


function PaymentListPage() {
    const dispatch = useDispatch();

    const { data: payments, requestData, resetRecords, updateRecord } = usePagedListApi(paymentsService.getPayments);
    const [searchParams, setSearchParams] = useSearchParams();


    // get query params
    const page = Number(searchParams.get('page')) || payments.pager.page;
    const searchFilters: any = {};
    //if (searchParams.get('name')) { searchFilters['name'] = searchParams.get('name') || '' }


    useEffect(() => {
        dispatch(changePageInfo({ title: "Payments" }));
    }, []);


    useEffect(() => {
        //getPayments();
    }, [searchParams]);


    const getPayments = async () => {
        await requestData({
            page: page,
            filters: searchFilters,
            otherProperties: {
                pageSize: 10,
                direction: 'asc',
                properties: 'name',
            },
        });
    };


    return (
        <div className=''>
            <div className='flex flex-wrap justify-between mb-1'>
                <span></span>
                <Button type='button' onClick={() => { }} className='mb-4'>Download Report</Button>
            </div>


            {
                // if there're payments
                //!payments.loadingError && !payments.loading && payments.list.length > 0 &&
                <React.Fragment>
                    <div className='max-w-full overflow-x-auto mb-6'>
                        <table className="border-collapse table-auto w-full">
                            <thead>
                                <tr className='text-left border-b-2 dark:border-gray-700'>
                                    <th className='py-6 px-6'>Account No./GL</th>
                                    <th className='py-6 px-6'>Amount</th>
                                    <th className='py-6 px-6'>Currency</th>
                                    <th className='py-6 px-6'>DR/CR Indicator</th>
                                    <th className='py-6 px-6'>TXN Code</th>
                                    <th className='py-6 px-6'>Narration</th>
                                    {/* <th className='py-6 px-6 text-right'>Action</th> */}
                                </tr>
                            </thead>
                            <tbody className="divide-y dark:divide-gray-700/60">
                                {
                                    [1, 2, 3, 4, 5, 6].map((paymentItem: any) =>
                                        <tr key={paymentItem}>
                                            <td className='py-6 px-6'>100020000</td>
                                            <td className='py-6 px-6'>5000</td>
                                            <td className='py-6 px-6'>GHS</td>
                                            <td className='py-6 px-6'>SUCCESS</td>
                                            <td className='py-6 px-6'></td>
                                            <td className='py-6 px-6'>Date,school name, student name, student ID, txn reference,</td>
                                            {/* <td className='py-6 px-6 whitespace-nowrap'>{format(new Date(paymentItem.createdDate), 'd LLL yyyy h:mm a')}</td> */}
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </div>

                    {/* <div className='flex justify-between flex-wrap'>
                        <p className='mb-3 mr-8 text-gray-500 dark:text-gray-400'>{paginationInfo(payments.pager.pageSize, payments.pager.totalCount, page)}</p>

                        <Pagination
                            currentPage={page}
                            pageSize={payments.pager.pageSize}
                            totalCount={payments.pager.totalCount}
                            onPageChange={(page) => {
                                setSearchParams(current => ({
                                    ...Object.fromEntries(current.entries()),
                                    page: page.toString(),
                                }));
                            }}
                        />
                    </div> */}
                </React.Fragment>
            }

            {
                // if payments are loading
                /*  !payments.loadingError && payments.loading &&
                 <ListLoader loadingText='Loading Payments' className='px-8 py-24' /> */
            }

            {
                // if there're no payments in the app
                !payments.loadingError && !payments.loading && payments.list.length === 0 && Object.keys(searchFilters).length === 0 &&
                <ListNoData title='No Payments Found' description='There are no payments currently setup in SmartSapp' className='px-8 py-24'>
                </ListNoData>
            }

            {
                // if there're no payments in the app
                !payments.loadingError && !payments.loading && payments.list.length === 0 && Object.keys(searchFilters).length > 0 &&
                <ListNoData title='No Payment Found' description='No payment was found for the selected scenarios' className='px-8 py-24' />
            }


            {
                payments.loadingError &&
                <ErrorLoading title='Error Loading Payments' message='There was a problem loading payments' className='px-8 py-24' onTryAgain={getPayments} />
            }
        </div>
    );
}

export default PaymentListPage;